<template>
    <div class="addtext_font align_value text_alignment_main_box_custom">
        <div class="form-group">
            <div class="layer_parent_div left_margin_zero">
                <button
                    @click="setValue('left')"
                    :class="'bcommon b1 large first ' + setActive('left')"
                >
                    <img class="no_active" src="./icon/left2.svg" />
                    <img class="y-active" src="./icon/left_alignac.svg" />
                </button>
                <button
                    @click="setValue('center')"
                    :class="'bcommon large ' + setActive('center')"
                >
                    <img class="no_active" src="./icon/center_gray.svg" />
                    <img class="y-active" src="./icon/center_alignac.svg" />
                </button>
                <button
                    @click="setValue('right')"
                    :class="'bcommon b2 large last ' + setActive('right')"
                >
                    <img class="no_active" src="./icon/right2.svg" />
                    <img class="y-active" src="./icon/right_alignac.svg" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TextAlign",
    props: ["value"],
    data: () => {
        return {};
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", e);
        },
        setActive(e) {
            return e == this.value ? "active" : "";
        }
    }
};
</script>

<style>
.layer_parent_div {
    display: flex;
    align-items: stretch;
    width: 100%;
    margin: 0px 15px;
}

.layer_parent_div .large {
    padding: 6px;
}

.bcommon {
    background-color: initial;
    color: #7796a8;
    border: 1px solid;
    border-radius: 0 !important;
    background: #7796a8;
    width: 40px;
}

.b1 {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
}

.b2 {
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}

.layer_parent_div .active {
    background: #e8e8e8 !important;
}
</style>
